import React from 'react';
import styled from 'styled-components';
import notfound from '../image/notfound.jpg';

// Styled component for the image container
const ImageContainer = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const PageUnderConstruction = () => {
    return (
        <ImageContainer>
            <StyledImage
                src={notfound}
                alt="Under Construction"
            />
        </ImageContainer>
    );
};

export default PageUnderConstruction;